import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  fetchTodosConversationSuccess,
  fetchTodosSuccess,
  showTodoMessage,
} from "actions/ToDo";
import {
  FETCH_ALL_TODO,
  FETCH_ALL_TODO_CONVERSATION,
} from "constants/ActionTypes";

const getTodos = async () => {
    try {
        // Example: Fetching todos from a REST API instead of Firebase
        const response = await fetch('/api/todos');  // Replace with your API endpoint
        const data = await response.json();

        const todos = [];

        data.forEach((rawData) => {
            const todo = rawData;

            // Convert object to array if todo.labels exist
            const labels = [];
            if (todo.labels) {
                todo.labels.forEach((label) => labels.push(label));
            }

            todo.labels = labels;
            todos.push(todo);
        });

        return todos;
    } catch (error) {
        console.error('Error fetching todos:', error);
        return error;
    }
};

const getTodosConversation = async () => {
    try {
        // Example: Fetching conversations from a REST API instead of Firebase
        const response = await fetch('/api/todos/conversation');  // Replace with your API endpoint
        const data = await response.json();

        const conversations = [];

        data.forEach((rawData) => {
            const conversation = rawData;

            // Convert object to array if conversationData exists
            const conversationDatas = [];
            if (conversation.conversationData) {
                conversation.conversationData.forEach((conversationData) =>
                    conversationDatas.push(conversationData)
                );
            }

            conversation.conversationData = conversationDatas;
            conversations.push(conversation);
        });

        return conversations;
    } catch (error) {
        console.error('Error fetching conversations:', error);
        return error;
    }
};

function* fetchTodoRequest() {
  try {
    const fetchedTodo = yield call(getTodos);
    yield put(fetchTodosSuccess(fetchedTodo));
  } catch (error) {
    yield put(showTodoMessage(error));
  }
}

function* fetchTodoConversationRequest() {
  try {
    const fetchedTodoConversation = yield call(getTodosConversation);
    yield put(fetchTodosConversationSuccess(fetchedTodoConversation));
  } catch (error) {
    yield put(showTodoMessage(error));
  }
}

export function* fetchTodos() {
  yield takeEvery(FETCH_ALL_TODO, fetchTodoRequest);
}

export function* fetchTodoConversation() {
  yield takeEvery(FETCH_ALL_TODO_CONVERSATION, fetchTodoConversationRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchTodoConversation), fork(fetchTodos)]);
}
